import React, { Component } from 'react';
import PropTypes from 'prop-types';

import passwordValidator from 'component-lib/PasswordValidator';

const validator = passwordValidator();

export function viewLogic(props) {
    return {
        ...props,
        isButtonDisabled: props.isButtonDisabled || !props.isStartedToSetPassword,
    };
}

export function stateLogic(component) {
    class ChangeForgottenPasswordStateLogic extends Component {
        static propTypes = {
            passwordConfig: PropTypes.shape({
                value: PropTypes.string.isRequired,
                onChange: PropTypes.func.isRequired,
            }).isRequired,
            confirmPasswordConfig: PropTypes.shape({
                value: PropTypes.string.isRequired,
                onChange: PropTypes.func.isRequired,
            }).isRequired,
            verifyToken: PropTypes.func,
            token: PropTypes.string,
            username: PropTypes.string.isRequired,
        };

        static defaultProps = {
            verifyToken: null,
            token: '',
        };

        constructor(props) {
            super(props);

            if (props.verifyToken) {
                props.verifyToken(props.token);
            }
        }

        get isStartedToSetPassword() {
            return !!(
                this.props.passwordConfig.value.length && this.props.confirmPasswordConfig.value.length &&
        !this.passwordErrorStatus.password.error.length &&
        !this.passwordErrorStatus.confirmPassword.error.length
            );
        }

        get passwordErrorStatus() {
            const { passwordConfig, confirmPasswordConfig, username } = this.props;
            const { isValidPassword } = validator.validatePassword(passwordConfig.value);

            const BASE_KEY = 'components.validation_issues';
            let passwordStatus = {};
            let confirmPasswordStatus = {};

            if (!isValidPassword && passwordConfig.value.length) {
                passwordStatus = {
                    status: 'error',
                    error: `${BASE_KEY}.password_complexity`,
                };
            }

            if (isValidPassword && confirmPasswordConfig.value.length) {
                confirmPasswordStatus = {
                    status: 'error',
                    error: `${BASE_KEY}.password_complexity`,
                };
            }

            if (isValidPassword && passwordConfig.value.length) {
                passwordStatus = {
                    status: 'success',
                    error: '',
                };

                if (confirmPasswordConfig.value.length &&
          passwordConfig.value === confirmPasswordConfig.value) {
                    confirmPasswordStatus = {
                        status: 'success',
                        error: '',
                    };
                }
            }

            if (username === passwordConfig.value) {
                passwordStatus = {
                    status: 'error',
                    error: `${BASE_KEY}.username_password_match`,
                };
            }

            return {
                password: passwordStatus,
                confirmPassword: confirmPasswordStatus,
            };
        }

        render() {
            return React.createElement(component, {
                ...this.props,
                isStartedToSetPassword: this.isStartedToSetPassword,
                passwordErrorStatus: this.passwordErrorStatus,
            });
        }
    }

    return ChangeForgottenPasswordStateLogic;
}
